import * as Sentry from '@sentry/react'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './app/App'
import { sessionApi } from './api/sessionApi'
import { VersionGate } from './version/VersionGate'

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

function maybeInitSentry() {
  void sessionApi.getGameConfigData({}).then((configData) => {
    const results = (
      configData.data as {
        data?: { results?: Array<{ sentryBackend?: boolean }> }
      }
    )?.data?.results
    if (results?.[0]?.sentryBackend === true) {
      const dsn = import.meta.env.VITE_SENTRY
      if (!dsn) return
      Sentry.init({
        dsn,
        tracesSampleRate: 1.0,
      })
    }
  }).catch(() => {
    /* config optional */
  })
}

maybeInitSentry()

createRoot(root).render(
  <StrictMode>
    <VersionGate>
      <App />
    </VersionGate>
  </StrictMode>,
)
